import { selectEnabledChecklistSchemas } from "services/schemas/selectors";
import createDeepEqualSelector from "utils/reselect/typescript/createDeepEqualSelector";

const selectOptions = createDeepEqualSelector(
    selectEnabledChecklistSchemas,
    schemas =>
        schemas.map(schema => ({
            key: schema.id,
            text: schema.name,
            value: schema.id
        }))
)

export {
    selectOptions
}
